import { QueryParam } from "../../../types/api/generic.type";
import { GetHistoryProjectRolesResponse } from "../../../types/api/projects.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const HistoryProjectRolesService = {
  async list(
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetHistoryProjectRolesResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";
    const response = await httpClient.get<GetHistoryProjectRolesResponse>(
      `v1/history/project-roles?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
      { signal },
    );
    return response;
  },
};

export default HistoryProjectRolesService;
